import React from 'react';
import PropTypes from 'prop-types';

import Search from '../Search';

import './styles.css';

function SearchHeader({ onSearch, right, ...props }) {

    const _renderRight = () => {
        if (right) 
            return (
                <div className="SearchHeader__right">
                    {right()}
                </div>
            );
        return null;
    }

    return (
        <div 
            className="SearchHeader"
            {...props}
        >
            <div className="SearchHeader__search">
                <Search 
                    onSearch={onSearch} 
                />
            </div>
            {_renderRight()}
        </div>
    );
}

SearchHeader.propTypes = {
    onSearch: PropTypes.func,
    right: PropTypes.func
};

export default SearchHeader;
